/** Return the canonical form of a valid BCP-47 tag, otherwise null. */
export function canonicalizeBcp47Locale(locale: string): string | null {
  const trimmed = locale.trim();
  if (!trimmed) return null;
  try {
    return Intl.getCanonicalLocales(trimmed)[0] ?? null;
  } catch {
    return null;
  }
}

/** Match a locale by its exact canonical primary language subtag. */
export function isSwedishLocale(locale: string): boolean {
  const canonical = canonicalizeBcp47Locale(locale);
  return canonical ? new Intl.Locale(canonical).language === 'sv' : false;
}

/** Canonicalize a BCP-47 tag, falling back to the browser tag and then English. */
export function resolveReplyLocale(
  configuredLocale: string | null | undefined,
  browserLocale: string | null | undefined,
): string {
  for (const candidate of [configuredLocale, browserLocale, 'en']) {
    const trimmed = candidate?.trim();
    if (!trimmed) continue;
    const canonical = canonicalizeBcp47Locale(trimmed);
    if (canonical) return canonical;
  }
  return 'en';
}
